/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../../../app/common/directives/trimValueAccessor';
import * as i4 from '../../../../../../../app/common/directives/ripples.directive';
import * as i5 from '../../../../../../../app/components/Managment/orderManagement/orderData/tabs/preparingDocTab.component';
import * as i6 from '../../../../../../../app/services/orderContentService';
const styles_PreparingDocTabComponent:any[] = ([] as any[]);
export const RenderType_PreparingDocTabComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PreparingDocTabComponent,data:{}});
function View_PreparingDocTabComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'card-header header card-header-text'],['data-background-color','#E07E3C']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      1,'h3',[['class','central-title text-uppercase']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['',
      ''])),(_l()(),i0.ɵted((null as any),[' ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getTitle();
    _ck(_v,3,0,currVal_0);
  });
}
function View_PreparingDocTabComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),22,'div',[['class',
      'card']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PreparingDocTabComponent_2)),i0.ɵdid(16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),16,'div',[['class','card-content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),13,'div',[['class',
          'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          10,'div',[['class','col-md-12']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),7,'textarea',([] as any[]),[[8,'readOnly',
              0],[8,'placeholder',0],[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'focusout'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,12)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,12).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,12)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,12)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('input' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,13).ngOnChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_5:any = ((<any>(_co.orderContent.Data.Data = $event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('focusout' === en)) {
              const pd_6:any = ((<any>_co.saveComment()) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(16384,(null as any),0,i3.TrimValueAccessor,[i0.Renderer2,
          i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any,p1_0:any) => {
        return [p0_0,p1_0];
      },[i2.DefaultValueAccessor,i3.TrimValueAccessor]),i0.ɵdid(671744,(null as any),
          0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,(null as any),0,i2.NgControlStatus,
          [i2.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n                '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.showTitle;
    _ck(_v,3,0,currVal_0);
    const currVal_10:any = _co.orderContent.Data.Data;
    _ck(_v,15,0,currVal_10);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.isReadOnly;
    const currVal_2:any = (_co.isReadOnly? '': 'Here you can write some information about this step');
    const currVal_3:any = i0.ɵnov(_v,17).ngClassUntouched;
    const currVal_4:any = i0.ɵnov(_v,17).ngClassTouched;
    const currVal_5:any = i0.ɵnov(_v,17).ngClassPristine;
    const currVal_6:any = i0.ɵnov(_v,17).ngClassDirty;
    const currVal_7:any = i0.ɵnov(_v,17).ngClassValid;
    const currVal_8:any = i0.ɵnov(_v,17).ngClassInvalid;
    const currVal_9:any = i0.ɵnov(_v,17).ngClassPending;
    _ck(_v,11,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,
        currVal_8,currVal_9);
  });
}
function View_PreparingDocTabComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'div',[['class',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          5,'div',[['class','col-md-12 text-center']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'button',[['class',
          'btn btn-round btn-dark-orange btn-wide complete-button margin-top-10']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.completeOrderEvent.emit(true)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i4.RipplesDirective,
          [i0.ElementRef,i0.Renderer2],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          [' ',' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = 'COMPLETE';
    _ck(_v,6,0,currVal_0);
  });
}
export function View_PreparingDocTabComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_PreparingDocTabComponent_1)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_PreparingDocTabComponent_3)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i5.PreparingDocTabComponent = _v.component;
    const currVal_0:any = _co.orderContent;
    _ck(_v,1,0,currVal_0);
    const currVal_1:boolean = (!_co.isReadOnly && _co.showContinue);
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_PreparingDocTabComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'order-prep-doc-tab',
      ([] as any[]),(null as any),(null as any),(null as any),View_PreparingDocTabComponent_0,
      RenderType_PreparingDocTabComponent)),i0.ɵdid(49152,(null as any),0,i5.PreparingDocTabComponent,
      [i6.OrderContentService],(null as any),(null as any))],(null as any),(null as any));
}
export const PreparingDocTabComponentNgFactory:i0.ComponentFactory<i5.PreparingDocTabComponent> = i0.ɵccf('order-prep-doc-tab',
    i5.PreparingDocTabComponent,View_PreparingDocTabComponent_Host_0,{orderContent:'orderContent',
        tabNumber:'tabNumber',isReadOnly:'isReadOnly',showTitle:'showTitle',showContinue:'showContinue',
        order:'order'},{completeOrderEvent:'completeOrderEvent'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/Managment/orderManagement/orderData/tabs/preparingDocTab.component.ngfactory.ts